/**
 * Created by weid on 2017/2/23.
 */
import React from 'react';
import { browserHistory } from 'react-router';
import * as qs from 'query-string';

const scripts = [];

export function getLocationOrigin() {
    return window.location.protocol + '//' + window.location.host;
}

export function getSign(urlString) {
    return urlString.indexOf('?') === -1 ? '?' : '&';
}

export function getToken() {
    return qs.parse(window.location.search).token;
}

export function getQueryValueByName(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    const r = window && window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
}

export function goBack() {
    browserHistory.goBack();
}

export function redirectTo(pathname, options = {}) {
    const query = { token: getToken() };
    const state = {};

    if (isPlainObject(options.query)) {
        Object.assign(query, options.query);
    }
    if (isPlainObject(options.state)) {
        Object.assign(state, options.state);
    }

    const method = options.replace ? 'replace' : 'push';
    if (options.reload) {
        setTimeout(() => {
            window.location.reload();
        }, 600);
    }
    browserHistory[method]({ pathname, query, state });
}

/**
 * 格式化金额，针对 input 输入框
 * eg: '12.30.' => '12.30'
 * eg: '.' => ''
 * eg: '09' => '9'
 * @param value {string} 被格式化的值
 * @param digits {number} 显示位数（保留几位小数）
 * @return value {string} 格式后的值
 */
export function formatAmountInput(value, digits) {
    if (value !== '') {
        // '.' => ''
        // '2c' => '2'
        value = value.replace(/^\.|[^\d.]/g, '');
        if (value !== '') {
            if (value.charAt(0) === '0' && value.charAt(1) !== '.') {
                // '09' => '9'
                // '00' => '0'
                value = !+value ? '0' : value.substring(1);
            } else {
                const tempValue = value.split('.');
                if (tempValue.length >= 2) {
                    if (typeof digits === 'number') {
                        // eg(digits = 2): '12.300' => '12.30'
                        if (digits) {
                            const decimals = tempValue[1].substring(0, digits);
                            value = tempValue[0] + '.' + decimals;
                        } else {
                            // '12.' => '12'
                            value = tempValue[0]; // eslint-disable-line
                        }
                    } else {
                        // '12.30.' => '12.30'
                        // '12..' => '12.'
                        value = tempValue[0] + '.' + tempValue[1];
                    }
                }
            }
        }
    }
    return value;
}

// 检查元素是否在某个元素里，与 jQuery.contains 等同
export function contains(container, target) {
    if (target) {
        while ((target = target.parentNode)) {
            if (container === target) {
                return true;
            }
        }
    }
    return false;
}

/**
 * 函数节流
 * @param  {Function} handler
 * @param  {Number}   delay 可选，值 >= 0
 * @param  {Number}   must  可选，值 >= 0
 * @return {Function}       run when trigger it's event
 */
export function throttle(handler, delay, must) {
    if (!delay && !must) {
        return handler;
    }

    let startTime = new Date();
    let timer;

    return function inner(e) {
        if (delay) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                handler.call(this, e);
            }, delay);
        } else if (new Date() - startTime > must) {
            startTime = new Date();
            handler.call(this, e);
        }
    };
}

// 类型检测
export function typeChecking(type, expectation) {
    return Object.prototype.toString.call(type) === expectation;
}

export function isPlainObject(obj) {
    return typeChecking(obj, '[object Object]');
}

export function loadScript(url) {
    if (scripts.indexOf(url) !== -1) {
        return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';

        script.onload = () => {
            scripts.push(url);
            resolve();
        };

        script.onerror = (err) => {
            reject(err);
        };

        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    });
}

export function removeElem(selector) {
    const elem = document.querySelector(selector);
    elem && elem.parentNode.removeChild(elem);
}

/**
 * JSONP 跨域加载
 * @param url
 * @returns {Promise}
 *
 * Example：
 *  jsonp('http://domain.com/some-url')
 *  .then(() => {
 *    console.log('loading success')
 *  })
 *  .catch((err) => {
 *    console.log(err)
 *  })
 */
export function jsonp(url) {
    const id = '_utils_jsonp_' + Date.now();
    url += getSign(url) + `callback=${id}`;

    return new Promise((resolve, reject) => {
        window[id] = (res) => {
            clearJsonpRemains(id);
            resolve(res);
        };
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = id;
        script.onerror = (err) => {
            clearJsonpRemains(id);
            reject(err);
        };
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    });
}

function clearJsonpRemains(id) {
    removeElem('#' + id);
    delete window[id];
}

/**
 * 深或浅拷贝，跟 jQuery extend 方法一致
 * extend( target [, object1 ] [, objectN ] )
 * extend( [ deep ,] target, object1 [, objectN ] )
 * @returns {object}
 */
export function extend() {
    const { isArray } = Array;
    const arg = arguments;
    let target = arg[0] || {};
    let deep = false;
    const { length } = arg;
    let i = 1;
    let value;
    let attr;
    let copyIsArray;

    if (typeof target === 'boolean') {
        deep = target;
        target = arg[1] || {};
        i++;
    }

    /* eslint-disable */

    for (; i < length; i++) {
        for (attr in arg[i]) {
            value = arg[i][attr];

            if (deep && (isPlainObject(value) || (copyIsArray = isArray(value)))) {
                let src = target[attr];

                if (copyIsArray) {
                    copyIsArray = false;
                    src = isArray(src) ? src : [];
                } else {
                    src = isPlainObject(src) ? src : {};
                }

                target[attr] = extend(deep, src, value);
            } else {
                target[attr] = value;
            }
        }
    }

    return target;
}

export function defineReadOnlyProperty(target, prop, value) {
    Object.defineProperty(target, prop, {
        value,
        writable: false,
        enumerable: true,
        configurable: false
    });
}

/**
 * 倒计时
 * @param callback          回调函数
 * @param countTime         倒计时秒数
 * @returns {number|*}      定时器 ID
 */
export function countDown(callback, countTime = 60) {
    let timer;
    const tick = () => {
        countTime--;
        if (!countTime) {
            clearInterval(timer);
        }
        callback(countTime);
    };

    tick();
    timer = setInterval(() => tick(), 1000);
    return timer;
}

/**
 * 函数防抖
 * @param  {Function} fn
 * @param  {Number}   delay 可选，值 >= 0
 */
export function debounce(fn, delay) {
    let timeid; // 设置一个定时器
    return function inner(parms) {
        clearTimeout(timeid);
        timeid = setTimeout(() => {
            fn.call(this, parms);
        }, delay);
    };
}



// WEBPACK FOOTER //
// ./src/public/js/utils/base.js